<template>
  <div id="app">
    <Header ref="header" />
    <Question ref="question" :question="index" :key="index" v-for="(q, index) in $store.state.questions" :gotoSlide="gotoSlide" :isVisibleSlide="isVisibleSlide" :analytics="analytics" />
    <BeforeResults ref="beforeresults" :gotoSlide="gotoSlide" :isVisibleSlide="isVisibleSlide" :analytics="analytics" />
    <Petition ref="petition" :gotoSlide="gotoSlide" :isVisibleSlide="isVisibleSlide" :analytics="analytics" />
    <Results ref="results" :gotoSlide="gotoSlide" :isVisibleSlide="isVisibleSlide" :analytics="analytics" />
    <Answers ref="answers" :gotoSlide="gotoSlide" :isVisibleSlide="isVisibleSlide" :analytics="analytics" />
    <Share ref="share" :gotoSlide="gotoSlide" :isVisibleSlide="isVisibleSlide" :analytics="analytics" />
    <Final ref="final" :gotoSlide="gotoSlide" :isVisibleSlide="isVisibleSlide" :analytics="analytics" />
    <Final2 ref="final2" :gotoSlide="gotoSlide" :isVisibleSlide="isVisibleSlide" :analytics="analytics" />
    <Thanks ref="thanks" :gotoSlide="gotoSlide" :isVisibleSlide="isVisibleSlide" :analytics="analytics" />
  </div>
</template>

<script>
import Header from './components/Header.vue';
import Question from './components/Question.vue';
import BeforeResults from './components/BeforeResults.vue'
import Petition from './components/Petition.vue'
import Results from './components/Results.vue'
import Answers from './components/Answers.vue'
import Share from './components/Share.vue'
import Final from './components/Final.vue'
import Final2 from './components/Final2.vue'
import Thanks from './components/Thanks.vue'

export default {
  name: 'app',
  components: {
    Header,
    Question,
    BeforeResults,
    Petition,
    Results,
    Answers,
    Share,
    Final,
    Final2,
    Thanks
  },
  methods: {
    gotoSlide(slide) {
      if (!this.isVisibleSlide(slide)) {
        this.$store.state.visibleSlides.push(slide);
      }
      setTimeout(() => this.$scrollTo('#slide_' + slide, '600'), 100);
    },
    isVisibleSlide(slide) {
      return this.$store.state.visibleSlides.indexOf(slide) !== -1;
    },
    analytics (action, label) {
      window.gtag = window.gtag || [];
      window.gtag('event', action, {
        'event_category': 'tuc-quiz',
        'event_label': label
      });
    }
  },
  mounted () {
    //FB text test
    var FBTester = new ABTester({ // eslint-disable-line
      cookieName: 'facebookVariant',
      experimentName: 'FacebookCopy',
      variants: [{
          name: 'Facebook Test 1',
          callback: () => {
            this.$store.state.variants.facebookText = 0;
            this.analytics('FacebookCopyTest', 'control');
          },
        },
        {
          name: 'Facebook Test 2',
          callback: () => {
            this.$store.state.variants.facebookText = 1;
            this.analytics('FacebookCopyTest', 'v1');
          },
        }
      ]
    });
    //FB image test
    var FBimgTester = new ABTester({ // eslint-disable-line
      cookieName: 'facebookImageVariant',
      experimentName: 'FacebookImg',
      variants: [{
          name: 'Facebook Image Test 1',
          callback: () => {
            this.$store.state.variants.facebookImg = 0;
            this.analytics('FacebookImageTest', 'control');
          },
        },
        {
          name: 'Facebook Image Test 2',
          callback: () => {
            this.$store.state.variants.facebookImg = 1;
            this.analytics('FacebookImageTest', 'v1');
          },
        }
      ]
    });
    //Whatsapp text test
    var WhatsappTester = new ABTester({ // eslint-disable-line
      cookieName: 'whatsappVariant',
      experimentName: 'Whatsapp',
      variants: [{
          name: 'Whatsapp Test 1',
          callback: () => {
            this.$store.state.variants.whatsapp = 0;
            this.analytics('WhatsappTest', 'control');
          },
        },
        {
          name: 'Whatsapp Test 2',
          callback: () => {
            this.$store.state.variants.whatsapp = 1;
            this.analytics('WhatsappTest', 'v1');
          },
        }
      ]
    });
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Open Sans', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
.slide {
  min-height: 100vh;
  padding: 100px 0 50px 0;
  background-size: cover;
  background: #fff;
}
.btn-light {
  display: block;
  margin: 10px auto;
  background: #ebebeb;
  border-radius: 0;
  font-size: 17px;
  padding: 15px;
  font-weight: bold;
  white-space: normal;
  cursor: pointer;
  &.red {
    background: #cd171e;
    color: #fff;
    &:hover, &:active, &:focus {
      background: #bd070e !important;
    }
  }
  &:hover, &:active, &:focus {
    color: #fff !important;
    background: #cd171e !important;
  }
}
.btn-skip {
  background: none;
  border: none;
  border-bottom: 1px solid #efefef;
  border-radius: 0;
  padding: 0px 0;
  color: #7d7d7d;
  //text-decoration: underline;
  margin: 10px auto;
  display: block;
  &:hover {
    color: #616161;
    border-bottom: 1px solid #cfcfcf;
  }
}
.answer-link {
  color: #fff;
  text-decoration: underline;
  &:hover {
    color: #fff;
  }
}
@media only screen and (min-width: 769px) {
  .mobile-only {
    display: none !important;
  }
}
@media only screen and (max-width: 768px) {
  .desktop-only {
    display: none !important;
  }
}
</style>
